import { directive, filter } from './app';
import { MAX_BULK_EXPORT, MAX_BULK_EXPORT_IN_SINGLE_FILE } from '../../../common/const/lei-products';

const excelContentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

directive('fixedSizeExport', [
  '$httpParamSerializer',
  '$rootScope',
  'httpWithRecaptcha',
  'Alert',
  /* @ngInject */
  function($httpParamSerializer, $rootScope, httpWithRecaptcha, Alert) {
    return {
      restrict: 'A',
      scope: {
        available: '<?',
        max: '<?'
      },
      template:
        '<a role="button" target="_blank" class="btn btn-success ml-1" ng-href="{{url}}" ng-class="{disabled: disabled || downloading}" ng-click="download($event)">{{label}}</a>',
      link: function(scope) {
        var params = {};
        function refresh() {
          var limit = Math.min(+scope.max || 0, +scope.available || 0);
          scope.disabled = !limit;
          scope.label = 'Export ' + (limit < +scope.available ? 'First ' + limit : 'All') + ' Items';
          scope.url =
            '/lei/exportFixedExcelBulk?' +
            $httpParamSerializer(
              Object.assign(params, {
                leiId: null,
                _limit: limit,
                _offset: 0,
                ts: Date.now()
              })
            );
        }

        scope.$watch('available', refresh);
        scope.$watch('max', refresh);

        scope.$on(
          '$destroy',
          $rootScope.$on('page-fetch', function(event, data) {
            params = data;
            refresh();
          })
        );

        scope.download = function(event) {
          event.preventDefault();

          // Disable button during download
          scope.downloading = true;

          const fullUrl = new URL(scope.url, window.location.origin); // Ensure a fully qualified URL
          const searchParams = new URLSearchParams(fullUrl.search);
          let size = MAX_BULK_EXPORT;
          for (const [key, value] of searchParams.entries()) {
            if (key === '_limit') {
              size = value;
              break;
            }
          }
          httpWithRecaptcha('export', { method: 'GET', url: fullUrl.href, data: undefined, responseType: 'blob' })
            .then(function(response) {
              const isZipFile = size > MAX_BULK_EXPORT_IN_SINGLE_FILE;
              const contentType = isZipFile ? 'application/zip' : excelContentType;
              const fileName = `LEI Bulk - ${size} ${size > 1 ? 'items' : 'item'}.${isZipFile ? 'zip' : 'xlsx'}`;

              const blob = new Blob([response.data], { type: contentType });
              const anchor = document.createElement('a');
              const url = URL.createObjectURL(blob);
              anchor.href = url;
              anchor.target = '_blank';
              anchor.download = fileName;
              document.body.appendChild(anchor);
              anchor.click();
              document.body.removeChild(anchor);
              URL.revokeObjectURL(url);

              // Re-enable button after download starts
              scope.downloading = false;
            })
            .catch(function(error) {
              console.error('Download failed:', error);
              if (error.status === 403) Alert.error('recaptcha', 'Access denied.');
              else Alert.error('exportFixedExcelBulk', 'Download failed.');

              // Re-enable button on error
              scope.downloading = false;
            });
        };
      }
    };
  }
]);

directive(
  'autoRenewExport',
  /* @ngInject */
  function($httpParamSerializer, $rootScope) {
    return {
      restrict: 'A',
      scope: {
        available: '<?'
      },
      template:
        '<a role="button" target="_blank" class="btn btn-success ml-1" ng-href="{{url}}" ng-class="{disabled: disabled}">Export All Items</a>',
      link(scope) {
        let params = {};
        function refresh() {
          scope.disabled = !+scope.available;
          scope.url =
            '/user/export/auto-renew/all?' +
            $httpParamSerializer(
              Object.assign(params, {
                ts: Date.now()
              })
            );
        }

        scope.$watch('available', refresh);

        scope.$on(
          '$destroy',
          $rootScope.$on('page-fetch', function(event, data) {
            params = data;
            refresh();
          })
        );
      }
    };
  }
);

filter('trueVals', function() {
  return function(obj) {
    return Object.keys(obj).filter(function(key) {
      return obj[key];
    });
  };
});

filter('exportGleifExcelBulkLink', [
  '$httpParamSerializer',
  function($httpParamSerializer) {
    return function(idArray) {
      if (!(Array.isArray(idArray) && idArray.length)) {
        return '';
      }
      return '/lei/exportGleifExcelBulk?' + $httpParamSerializer({ ids: idArray });
    };
  }
]);

filter('exportExcelBulkLink', [
  '$httpParamSerializer',
  function($httpParamSerializer) {
    // claim-renew exports the dedicated workbook (adds the required authorizationForm column) so the
    // round-trip re-uploads cleanly; every other action keeps the update/renew workbook.
    return function(idArray, action) {
      if (!(Array.isArray(idArray) && idArray.length)) {
        return '';
      }
      const params = { ids: idArray };
      if (action === 'claim-renew') {
        params.type = action;
      }
      return '/lei/exportExcelBulk?' + $httpParamSerializer(params);
    };
  }
]);
